export default __webpack_public_path__ + "dist/media/AddProject.b24e86b8.svg";